/** Comparison operators for a {@link JcQuery.where} constraint. */
export type JcWhereOp =
    | '=='
    | '!='
    | '<'
    | '<='
    | '>'
    | '>='
    | 'array-contains'
    | 'array-contains-any'
    | 'in'
    | 'not-in';

/** Sort direction for a {@link JcQuery.orderBy} constraint. */
export type JcOrderDirection = 'asc' | 'desc';

/**
 * A Firebase-free description of a single query constraint. Built via
 * {@link JcQuery} and translated to a Firestore `QueryConstraint` by
 * {@link BaseFirestoreService}'s `onList` / `list`.
 */
export type JcQueryConstraint =
    | { readonly kind: 'where'; readonly field: string; readonly op: JcWhereOp; readonly value: unknown }
    | { readonly kind: 'orderBy'; readonly field: string; readonly direction: JcOrderDirection }
    | { readonly kind: 'limit'; readonly count: number }
    | { readonly kind: 'limitToLast'; readonly count: number };

/** Builders for the query constraints accepted by collection reads. */
export const JcQuery = {
    /** Keeps documents whose `field` relates to `value` by `op`. */
    where(field: string, op: JcWhereOp, value: unknown): JcQueryConstraint {
        return { kind: 'where', field, op, value };
    },

    /** Orders results by `field` (ascending unless `direction` says otherwise). */
    orderBy(field: string, direction: JcOrderDirection = 'asc'): JcQueryConstraint {
        return { kind: 'orderBy', field, direction };
    },

    /** Keeps only the first `count` results. Requires an `orderBy`. */
    limit(count: number): JcQueryConstraint {
        return { kind: 'limit', count };
    },

    /** Keeps only the last `count` results. Requires an `orderBy`. */
    limitToLast(count: number): JcQueryConstraint {
        return { kind: 'limitToLast', count };
    },
};
